import { Component, OnInit } from '@angular/core';
import { ApiServiceEnum } from 'src/app/helpers/enum';

@Component({
    selector: 'plan-fund',
    templateUrl: './plan-fund.component.html',
    styleUrl: './plan-fund.component.css',
    standalone: false
})
export class PlanFundComponent implements OnInit {

  service = ApiServiceEnum.WILSHIRE_PLAN;

  ngOnInit(): void {}

}
